<template>
  <v-layout align-start>
    <v-flex>
      <v-app id="inspire">
        <v-card max-width="1200">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6" class="py-0">
                <v-dialog
                  ref="dialog1"
                  v-model="modal1"
                  :return-value.sync="fecha1"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fecha1"
                      :readonly="fecha1 == 1"
                      label="Fecha de Inicio"
                      prepend-icon="event"
                      v-bind="attrs"
                      v-on="on"
                      solo
                      @click="listar()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha1"
                    scrollable
                    locale="es-es"
                    :readonly="fecha1 == 1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal1 = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog1.save(fecha1), listar()"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="12" md="6" class="py-0">
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="fecha2"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha2"
                      :readonly="fecha2 == 1"
                      label="Fecha Fin"
                      prepend-icon="event"
                      v-on="on"
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha2"
                    scrollable
                    locale="es-es"
                    :readonly="fecha2 == 1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(fecha2), listar()"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
          </v-container>

          <v-container>
            <v-toolbar color="primary" dark>
              <v-icon>savings</v-icon>
              <v-spacer></v-spacer>

              <v-toolbar-title>Relacion de Creditos a Capturar</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn icon @click="mostrarNuevo()">
                <v-icon>add</v-icon>
              </v-btn>
            </v-toolbar>

            <v-row>
              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-card>
                  <v-card-title>Abono</v-card-title>
                  <v-card-text>
                    <h1 class="text-md-center">
                      {{ calcularabono }}
                    </h1>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-select
                  v-model="clienteid"
                  :items="clienteselect"
                  label="Cliente"
                  outlined
                  v-on:change="listarcreditovigente()"
                ></v-select>
              </v-col>

              <v-row>
                <v-col cols="12" sm="12" md="12" class="pa-3">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Busca por Ticket, Vale, Factura Etc."
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-row>

            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="creditovigenteselect"
              :single-select="singleSelect"
              :search="search"
              item-key="creditoid"
              show-select
              class="elevation-1 pa-0"
            >
              <template v-slot:top>
                <v-switch
                  v-model="singleSelect"
                  label="Seleccionar Todos"
                  class="pa-3"
                ></v-switch>
              </template>

              <template v-slot:item.creditoestatus="{ item }">
                <v-chip :color="getColor(item.creditoestatus)" dark>
                  SIN PAGO
                </v-chip>
              </template>

              <template v-slot:item.action="{ item }">
                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <v-icon @click="vertickets(item)" v-on="on"
                      >remove_red_eye</v-icon
                    >
                  </template>
                  <span>Tickets</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-container>
        </v-card>
      </v-app>

      <v-dialog v-model="modeltickets" max-width="1200">
        <v-card>
          <v-alert shaped dark color="info">
            Datos del Ticket
          </v-alert>
          <v-card-title>
            <span class="headline">Actualiza Datos del Ticket</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-data-table
                :headers="headersvaleyticket"
                :items="creditovaleyticket"
              >
                <template v-slot:item.creditovale="props">
                  <v-text-field v-model="props.item.creditoid"></v-text-field>
                </template>

                <template v-slot:item.creditoticket="props">
                  <v-text-field
                    v-model="props.item.creditoticket"
                  ></v-text-field>
                </template>

                <template v-slot:item.creditoimporte="props">
                  <v-text-field
                    v-model="props.item.creditoimporte"
                    type="number"
                  ></v-text-field>
                </template>

                <template v-slot:item.creditofactura="props">
                  <v-text-field
                    v-model="props.item.creditofactura"
                    type="number"
                  ></v-text-field>
                </template>

                <template v-slot:item.creditolitros="props">
                  <v-text-field
                    v-model="props.item.creditolitros"
                    type="number"
                  ></v-text-field>
                </template>

                <template v-slot:item.creditounidad="props">
                  <v-text-field
                    v-model="props.item.creditolitros"
                  ></v-text-field>
                </template>

                <template v-slot:item.creditoautorizaocarga="props">
                  <v-text-field
                    v-model="props.item.creditoautorizaocarga"
                  ></v-text-field>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import VueExcelXlsx from "vue-excel-xlsx";
import { StreamBarcodeReader } from "vue-barcode-reader";

/*

                                <div class="hello">
    <StreamBarcodeReader
      @decode="(a, b, c) => onDecode(a, b, c)"
      @loaded="() => onLoaded()"
    ></StreamBarcodeReader>
    Input Value: {{ text || "Nothing" }}
  </div>
*/

export default {
  components: {
    StreamBarcodeReader,
  },
  data() {
    return {
      guardarvisible: 0,
      TablaVisible: 0,
      fletefecha: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      fecha1: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      fecha2: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      modal: false,
      modal1: false,
      menu: false,
      modal: false,
      clienteid: "",
      clientenombre: "",
      clienteselect: [],
      creditofecha: "",
      clienteid: "",
      creditoimporte: "",
      creditoticket: "",
      creditovale: "",
      combustibleid: "",
      combustibleselect: [],
      creditofactura: "",
      //
      pdfPreview: "",
      imagenopdf: 0,

      options: {
        locale: "en-US",
        prefix: "$",
        suffix: "",
        length: 11,
        precision: 2,
      },

      creditoselect: [],
      guardarvisiblesino: 0,
      guardarditasino: 0,
      //
      movimientoid: "",
      liquidacionid: "",
      servicioid: "",
      file: "",
      //
      text: "",
      id: null,
      clienteid: "",
      clientenombre: "",
      clienteselect: [],
      creditovigenteselect: [],
      selected: [],
      search: "",
      headers: [
        { text: "Id", value: "creditoid" },
        { text: "Fecha", value: "creditofecha" },
        { text: "Magna", value: "magna" },
        { text: "Diesel", value: "premium" },
        { text: "Premium", value: "diesel" },
        { text: "Ticket", value: "creditoticket" },
        { text: "Vale", value: "creditovale" },
        { text: "Importe", value: "creditoimporte" },
        { text: "Estatus", value: "creditoestatus" },
        { text: "Accion", value: "action", sortable: false },
      ],
      headersvaleyticket: [
        { text: "Vale", value: "creditovale" },
        { text: "Ticket", value: "creditoticket" },
        { text: "Importe", value: "creditoimporte" },
        { text: "Factura", value: "creditofactura" },
        { text: "Litros", value: "creditolitros" },
        { text: "Unidad", value: "creditounidad" },
        { text: "Autorizo o Cargo", value: "creditoautorizaocarga" },
      ],
      creditovaleyticket: [],
      modeltickets: 0,
      singleSelect: false,
    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    calcularTotal: function() {
      var resultado = 0.0;
      for (var i = 0; i < this.creditovigenteselect.length; i++) {
        resultado =
          resultado + parseFloat(this.creditovigenteselect[i].creditoimporte);
      }
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(resultado);
    },
    calcularabono: function() {
      var resultado = 0.0;
      for (var i = 0; i < this.selected.length; i++) {
        resultado = resultado + parseFloat(this.selected[i].creditoimporte);
      }
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(resultado);
    },
  },

  props: {
    msg: String,
  },

  watch: {},

  created() {
    this.selectgasolinatipo();
    this.clientecredito();
    this.listar();
  },

  //
  methods: {
    onDecode(a, b, c) {
      console.log(a, b, c);
      this.text = a;
      if (this.id) clearTimeout(this.id);
      this.id = setTimeout(() => {
        if (this.text === a) {
          this.text = "";
        }
      }, 5000);
    },
    onLoaded() {
      console.log("load");
    },

    getHumanDate: function(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    mostrarNuevo() {
      this.TablaVisible = 1;
      this.guardarvisiblesino = 0;
      this.limpiar();
    },

    vertickets(item) {
      this.modeltickets = 1;
      this.listarcreditoporvaleyticket(item);
    },

    clientecredito() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/clientes/listarempresa/" + 1, configuracion)
        .then(function(response) {
          me.liquidaselect = [];
          listaArray = response.data.cliente;
          listaArray.map(function(x) {
            me.clienteselect.push({
              text: x.clientenombre,
              value: x.clienteigas,
            });
          });
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    listarcreditovigente() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get("api/creditos/creditosporcliente/" + me.clienteid, configuracion)
        .then(function(response) {
          me.creditovigenteselect = response.data.credito;
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    listarcreditoporvaleyticket(item) {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get(
          "api/creditos/creditosporvaleyticket/" +
            item.creditovale +
            "/" +
            item.creditoticket,
          configuracion
        )
        .then(function(response) {
          me.creditovaleyticket = response.data.credito;
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    ocultarNuevo() {
      this.TablaVisible = 0;
      this.limpiar();
    },

    getColor(socioestatus) {
      if (socioestatus == 1) return "yellow";
      if (socioestatus == 3) return "#DA0707";
    },

    guardar() {
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      let formData = new FormData();

      formData.append("clienteid", me.clienteid);
      formData.append("combustibleid", me.combustibleid);
      formData.append("creditoimporte", me.creditoimporte);
      formData.append("creditofecha", me.creditofecha);
      formData.append("creditoticket", me.creditoticket);
      formData.append("creditovale", me.creditovale);
      formData.append("creditofactura", me.creditofactura);
      formData.append(
        "creditousuariocaptura",
        me.$store.state.usuario.usuarioid
      );
      formData.append("file0", me.file);
      formData.append("movimientoid", me.movimientoid);
      formData.append("liquidacionid", me.liquidacionid);
      formData.append("servicioid", me.servicioid);

      axios
        .post("api/creditos/crear", formData, configuracion)
        .then(function(response) {
          me.limpiar();
          me.listar();
          me.TablaVisible = 0;
          me.$swal("Flete Capturado con Exito");
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    clientebusca() {
      let me = this;
      var listaArray = [];
      var nombre = "";
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/clientes/listarid/" + me.clienteid)
        .then(function(response) {
          me.$swal("Cliente: " + response.data.cliente.clientenombre);
          me.clientenombre = response.data.cliente.clientenombre;
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("El Cliente No Existe");
            me.clienteigas = "";
          }
        });
    },

    close() {
      this.TablaVisible = 0;
      this.fleteexcel = 0;
      this.modeltickets = 0;
    },

    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get(
          "api/movimientos/creditopordias/" + me.fecha1 + "/" + me.fecha2,
          configuracion
        )
        .then(function(response) {
          me.creditoselect = response.data.credito;
        })
        .catch(function(error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectgasolinatipo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/combustibles/listarcombustibles", configuracion)
        .then(function(response) {
          listaArray = response.data.combustible;
          listaArray.map(function(x) {
            me.combustibleselect.push({
              text: x.combustiblenombre,
              value: x.combustibleid,
            });
          });
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    handleFileUpload() {
      /*
                Set the local file variable to what the user has selected.
              */
      this.file = this.$refs.file.files[0];

      /*
                Initialize a File Reader object
              */
      let reader = new FileReader();

      /*
                Add an event listener to the reader that when the file
                has been loaded, we flag the show preview as true and set the
                image to be what was read from the reader.
              */
      reader.addEventListener(
        "load",
        function() {
          if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
            this.imagenopdf = 1;
            this.extencion = 1;
            this.showPreview = true;
            this.imagePreview = reader.result;
          }

          if (/\.(pdf)$/i.test(this.file.name)) {
            this.imagenopdf = 2;
            this.extencion = 2;
            this.showPreview = true;
            this.pdfPreview = reader.result;
          }
        }.bind(this),
        false
      );

      /*
                Check to see if the file is not empty.
              */
      if (this.file) {
        /*
                    Ensure the file is an image file.
                  */
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
        if (/\.(pdf)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },

    ver(item) {
      this.TablaVisible = 1;
      this.guardarvisiblesino = 1;
      this.guardarditasino = 0;
      this.fletefecha = item.fletefecha;
      this.facturaid = item.facturaid;
      this.combustibleid = item.combustibleid;
      this.clienteid = item.clienteid;
      this.fletelitros = item.fletelitros;
      this.tadid = item.tadid;
      this.fletefactorpemex = item.fletefactorpemex;
      this.fletepeaje = item.fletepeaje;
      this.fletemaspeaje = item.fletemaspeaje;
      this.fletecartaporte = item.fletecartaporte;
    },

    editar(item) {
      this.TablaVisible = 1;
      this.guardarvisiblesino = 0;
      this.guardarditasino = 1;
      this.creditofecha = item.movimientofecha;
      this.clienteid = item.clienteigas;
      this.clientenombre = item.clientenombre;
      this.creditovale = item.credito;
      this.creditoimporte = item.movimientoimporte;
      this.movimientoid = item.movimientoid;
      this.liquidacionid = item.liquidacionid;
      this.servicioid = item.servicioid;
    },

    eliminar(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Eliminar",
        text:
          "El Flete: " + item.fleteid + " Numero de Factura: " + item.facturaid,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          axios
            .put("api/fletes/eliminar/" + item.fleteid, {}, configuracion)
            .then(function(response) {
              me.botonver = 1;
              me.limpiar();
              me.listar();
              me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
              me.close();
            })
            .catch(function(error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });
    },

    limpiar() {
      (this.creditofecha = moment(
        this.$store.state.usuario.fecha,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD")),
        (this.clienteid = "");
      this.clientenombre = "";
      this.combustibleid = "";
      this.creditoimporte = "";
      this.creditoticket = "";
      this.creditovale = "";
      this.creditofactura = "";
      this.file = "";
      this.movimientoid = "";
      this.liquidacionid = "";
      this.servicioid = "";
    },
  },
};
</script>
